
import { Component, Vue, Watch } from "vue-property-decorator";
import { Toast, Dialog } from "vant";
import { PageService, EmployerStorePopupService } from "src/services";
import tabbar from "src/components/tabbar";
import router from "src/router";

import BannerPage from "src/views/components/banner/page.vue";
import TitlePage from "src/views/components/title/page.vue";
import NavigationPage from "src/views/components/navigation/page.vue";
import ProductPage from "src/views/components/product/page.vue";
import InformationPage from "src/views/components/information/page.vue";
import Personal from "src/views/components/personal/page.vue";
import SearchPage from 'src/views/components/search/page.vue';
import CityfilterPage from 'src/views/components/cityfilter/page.vue';
import PrefecturePage from "src/views/components/prefecture/page.vue";
import OrderPage from "src/views/components/order/page.vue";
import ProductGroupPage from "src/views/components/productGroup/page.vue";
import RightsPage from "src/views/components/rights/page.vue";
import CouponPage from "src/views/components/coupon/page.vue";
import vueWaterfallEasy from 'src/utils/vue-waterfall-easy/vueWaterfallEasy';

import { tools } from "src/utils";

@Component({
    components:
    {
        tabbar,
        BannerPage,
        TitlePage,
        NavigationPage,
        ProductPage,
        PrefecturePage,
        OrderPage,
        InformationPage,
        Personal,
        SearchPage,
        CityfilterPage,
        ProductGroupPage,
        RightsPage,
        CouponPage,
        vueWaterfallEasy
    }
})
export default class HealthProductHome extends Vue
{
    /**
     * 菜单列表
     * @protected
     */
    private menuList:Array<any> = 
    [
        {
            componentType: 1,
            name: "轮播图",
            pageComponent: "BannerPage",
        },
        {
            componentType: 2,
            name: "标题文本",
            pageComponent: "TitlePage",
        },
        {
            componentType: 3,
            name: "导航栏",
            pageComponent: "NavigationPage",
        },
        {
            componentType: 4,
            name: "产品",
            pageComponent: "ProductPage",
        },
        {
            componentType: 7,
            name: "店铺信息",
            pageComponent: "InformationPage",
        },
        {
            componentType: 8,
            name: "专区",
            pageComponent: "PrefecturePage",
        },
        {
            componentType: 9,
            name: "个人信息",
            pageComponent: "Personal",
        },
        {
            componentType: 10,
            name: "订单",
            pageComponent: "OrderPage",
        },
        {
            componentType: 11,
            name: "产品分组",
            pageComponent: "ProductGroupPage",
        },
        {
            componentType: 12,
            name: "商品搜索",
            pageComponent: "SearchPage",
        },
        {
            componentType: 13,
            name: "城市筛选",
            pageComponent: "CityfilterPage",
        },
        {
            componentType: 14,
            name: "权益产品",
            pageComponent: "RightsPage",
        },
        {
            componentType: 15,
            name: "优惠券",
            pageComponent: "CouponPage",
        },
        
    ];

    /**
     * 首页自定义数据
     * @private
     * @returns any
     */
    protected pageData: any = {
        properties: "",
        pageType: null,
        name: "",
        id: null,
        enable: false,
        employerId: null,
        components: [],
        bgColor:"#f7f7f7",
        hasWaterfall: false
    };

    /**
     * 页面样式
     * @private
     * @returns any
     */
    protected pageStyle: any = {};
    
    /**
     * 瀑布流数据
     */
    protected waterfallData: any = {};

    /**
     * 除瀑布流数据
     */
    protected otherData: any = {};

    /**
     * 推广弹窗信息
     * @private
     * @returns any
     */
    private get storePopupObj(): any
    {
        return this.$store.state.storePopupObj || null;
    }

    /**
     * 推广弹窗是否已显示过
     * @private
     * @returns any
     */
    private get showedStorePopup(): any
    {
        let data = {home: false, personalCenter: false};
        if (localStorage.getItem("showedStorePopup")) {
            return JSON.parse(localStorage.getItem("showedStorePopup"))
        }
        else {
            localStorage.setItem("showedStorePopup", JSON.stringify(data));
            return data;
        }
    }

    /**
     * 推广弹窗弹出位置map
     * @private
     * @returns object
     */
     private popupPositionMap: any = {
        home: 0,
        personalCenter: 1
    }

    /**
     * 当路由发生变化的时候操作。
     * @protected
     * @param {any} - to 当前路由实例。
     * @returns {void}
     */
    @Watch("$route", {deep: true, immediate: true})
    protected updateOpen(to: any): void
    {
        this.getPageData();
    }

    /**
     * 获取首页配置信息
     * @private
     * @returns void
     */
    private async getPageData(): Promise<void>
    {
        try
        {
            let personalCenterType = 3;
            let {content: result} = await PageService.instance.getPage({pageType: personalCenterType});
            if (result.data)
            {
               this.pageData = result.data;
               let components = [];    // 转译
                result.data.components.forEach(element => {
                    let json = {componentType: element.componentType, properties: element.properties, icon: "", name: "", pageComponent: "", configComponent: ""};
                    let temObj = this.menuList.filter(res => res.componentType == element.componentType)[0];
                    json.icon = temObj.icon;
                    json.name = temObj.name;
                    json.pageComponent = temObj.pageComponent;
                    json.configComponent = temObj.configComponent;
                    components.push(json);
                });
                this.pageData.components = components;
                this.pageData.employerId = result.data.employerId;
                this.pageData.enable = result.data.enable;
                this.pageData.id = result.data.id;
                this.pageData.name = result.data.name;
                this.pageData.pageType = result.data.pageType;
                this.pageData.properties = result.data.properties;
                this.pageData.bgColor = result.data.properties.bgColor;
                this.pageStyle = {'background-color': result.data.properties && result.data.properties.bgColor || ''};
                
                this.pageData.hasWaterfall = result.data.components.filter(item => item.componentType == 11).length > 0;
                if (this.pageData.hasWaterfall) {
                    this.waterfallData = result.data.components.filter(item => item.componentType == 11)[0];
                }
                this.otherData = result.data.components.filter(item => item.componentType != 11);

                document.title = result.data.properties.navigateTitle || "健康产品";
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }
    }

    /**
     * 自定义组件获取的消息
     * @private
     * @returns void
     */
    private diyMsg (data): void
    {
        if (data.type == 404)   // 体检报告
        {
            // this.checkPrivacyTerm();
            router.push({ name: "reportAppointmentList" });
        }
    } 

    /**
     * 先判断是否有未同意的协议
     * @private
     * @returns void
     */
    //  private async checkPrivacyTerm(): Promise<void>
    // {
    //     try
    //     {
    //         // let {content: result} = await PrivacyTermService.instance.checkPrivacyTerm();
    //         // if(result.data)
    //         // {
    //         //     this.privacyTermInfo = Object.assign({}, result.data.privacyTermInfo);
                
                
    //         //     if (!result.data.isAgree)
    //         //     {
    //         //         this.onReport();
    //         //     }
    //         //     else
    //         //     {
    //         //         // 无需授权直接进入体检报告列表
    //         //         router.push({name: "reportAppointmentList"});
    //                 // router.push({name: "identityVerify"});
    //         //     }
    //         // }

    //         // 确认客户是否已经验证过是本人
    //         let {content:result} = await ReportService.instance.checkIdentity()
    //         if(!result.data.checked) {
    //             router.push({ name: "identityVerify" });
    //         } else {
    //             router.push({ name: "reportAppointmentList" });
    //         }


    //     }catch(err)
    //     {
    //         Toast(JSON.stringify(err));
    //     }
        
    // }

    protected onWeatchMiniBack = () => {
        ((wx as any).miniProgram as any)?.navigateBack();  // 退回到小程序
    }

    protected async created() {
        if (await tools.isWeatchMini())
        {
            if (this.$route.query.isCloseMiniWx)
            {
                // 监听浏览器返回动作
                window.addEventListener("popstate", this.onWeatchMiniBack, true);
            }
        }
    }

    protected async destroyed() {
        if (await tools.isWeatchMini())
        {
            setTimeout(() => {
                window.removeEventListener("popstate", this.onWeatchMiniBack, true);
            }, 100);
        }
    }

    /**
     * 获取店铺首页推广弹窗服务
     * @private
     * @returns void
     */
    private async getStorePopup(): Promise<void>
    {
        try
        {
            let popupPosition = this.popupPositionMap.personalCenter;
            let {content: result} = await EmployerStorePopupService.instance.getStorePopup(popupPosition);
            if (result.data)
            {
                // 处理跳转链接
                if (result.data.jumpLink) {
                    result.data.jumpLink = JSON.parse(result.data.jumpLink);
                    // 获取选中数据id
                    if (result.data.jumpLink.dataList && result.data.jumpLink.dataList.length) {
                        result.data.jumpLink.ids = result.data.jumpLink.dataList.map(item => item.id);
                    }
                }
                this.$store.dispatch('setStorePopupObj', {
                    ...this.storePopupObj,
                    personalCenter: result.data,
                });
            }
            else {
                this.$store.dispatch('setStorePopupObj', {
                    ...this.storePopupObj,
                    personalCenter: null,
                });
                this.showedStorePopup && localStorage.setItem("showedStorePopup", JSON.stringify({
                    ...this.showedStorePopup,
                    personalCenter: false,
                }));
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }
    }

    /**
     * dom加载完
     * @protected
     * @returns void
     */
    protected mounted() {
        if (localStorage.getItem("userInfo")) {
            this.getStorePopup();
        }
    }
    
}
